var map = {
	"./2010/People/Index": 34504,
	"./2010/People/Index.vue": 34504,
	"./2010/People/error": 57102,
	"./2010/People/error.json": 57102,
	"./2010/Program/Index": 26987,
	"./2010/Program/Index.vue": 26987,
	"./2011/People/Index": 30170,
	"./2011/People/Index.vue": 30170,
	"./2011/People/error": 69016,
	"./2011/People/error.json": 69016,
	"./2011/Program/Index": 54651,
	"./2011/Program/Index.vue": 54651,
	"./2012/People/Index": 583,
	"./2012/People/Index.vue": 583,
	"./2012/People/organizers": 76554,
	"./2012/People/organizers.json": 76554,
	"./2012/People/session-chairs": 60069,
	"./2012/People/session-chairs.json": 60069,
	"./2012/People/speakers": 95375,
	"./2012/People/speakers.json": 95375,
	"./2012/Program/Index": 34099,
	"./2012/Program/Index.vue": 34099,
	"./2012/Program/program": 74258,
	"./2012/Program/program.json": 74258,
	"./2013/People/Index": 27475,
	"./2013/People/Index.vue": 27475,
	"./2013/People/organizers": 7259,
	"./2013/People/organizers.json": 7259,
	"./2013/People/session-chairs": 82926,
	"./2013/People/session-chairs.json": 82926,
	"./2013/People/speakers": 5047,
	"./2013/People/speakers.json": 5047,
	"./2013/Program/Index": 81943,
	"./2013/Program/Index.vue": 81943,
	"./2013/Program/program": 27402,
	"./2013/Program/program.json": 27402,
	"./2014/People/Index": 887,
	"./2014/People/Index.vue": 887,
	"./2014/People/organizers": 43209,
	"./2014/People/organizers.json": 43209,
	"./2014/People/session-chairs": 59996,
	"./2014/People/session-chairs.json": 59996,
	"./2014/People/speakers": 64437,
	"./2014/People/speakers.json": 64437,
	"./2014/Program/Index": 81254,
	"./2014/Program/Index.vue": 81254,
	"./2014/Program/program": 82323,
	"./2014/Program/program.json": 82323,
	"./2015/People/Index": 98167,
	"./2015/People/Index.vue": 98167,
	"./2015/People/organizers": 54971,
	"./2015/People/organizers.json": 54971,
	"./2015/People/session-chairs": 47306,
	"./2015/People/session-chairs.json": 47306,
	"./2015/People/speakers": 23866,
	"./2015/People/speakers.json": 23866,
	"./2015/Program/Index": 21633,
	"./2015/Program/Index.vue": 21633,
	"./2015/Program/program": 36123,
	"./2015/Program/program.json": 36123,
	"./2016/People/Index": 93828,
	"./2016/People/Index.vue": 93828,
	"./2016/People/organizers": 73097,
	"./2016/People/organizers.json": 73097,
	"./2016/People/session-chairs": 94048,
	"./2016/People/session-chairs.json": 94048,
	"./2016/People/speakers": 60920,
	"./2016/People/speakers.json": 60920,
	"./2016/Program/Index": 14823,
	"./2016/Program/Index.vue": 14823,
	"./2016/Program/program": 31811,
	"./2016/Program/program.json": 31811,
	"./2017/People/Index": 36805,
	"./2017/People/Index.vue": 36805,
	"./2017/People/organizers": 3262,
	"./2017/People/organizers.json": 3262,
	"./2017/People/session-chairs": 72261,
	"./2017/People/session-chairs.json": 72261,
	"./2017/People/speakers": 98355,
	"./2017/People/speakers.json": 98355,
	"./2017/Program/Index": 57782,
	"./2017/Program/Index.vue": 57782,
	"./2017/Program/program": 57272,
	"./2017/Program/program.json": 57272,
	"./2018/People/Index": 15902,
	"./2018/People/Index.vue": 15902,
	"./2018/People/organizers": 49821,
	"./2018/People/organizers.json": 49821,
	"./2018/People/session-chairs": 27236,
	"./2018/People/session-chairs.json": 27236,
	"./2018/People/speakers": 62978,
	"./2018/People/speakers.json": 62978,
	"./2018/Program/Index": 31638,
	"./2018/Program/Index.vue": 31638,
	"./2018/Program/program": 71491,
	"./2018/Program/program.json": 71491,
	"./2019/Index": 89981,
	"./2019/Index.vue": 89981,
	"./2019/People/Index": 12091,
	"./2019/People/Index.vue": 12091,
	"./2019/People/organizers": 96180,
	"./2019/People/organizers.json": 96180,
	"./2019/People/session-chairs": 35371,
	"./2019/People/session-chairs.json": 35371,
	"./2019/People/speakers": 48466,
	"./2019/People/speakers.json": 48466,
	"./2019/Program/Index": 79146,
	"./2019/Program/Index.vue": 79146,
	"./2019/Program/program": 58953,
	"./2019/Program/program.json": 58953,
	"./2020/People/Index": 62910,
	"./2020/People/Index.vue": 62910,
	"./2020/People/organizers": 61320,
	"./2020/People/organizers.json": 61320,
	"./2020/People/session-chairs": 1229,
	"./2020/People/session-chairs.json": 1229,
	"./2020/People/speakers": 73503,
	"./2020/People/speakers.json": 73503,
	"./2020/Program/Index": 20402,
	"./2020/Program/Index.vue": 20402,
	"./2020/Program/program": 42895,
	"./2020/Program/program.json": 42895,
	"./2021/Index": 92591,
	"./2021/Index.vue": 92591,
	"./2021/People/Index": 11768,
	"./2021/People/Index.vue": 11768,
	"./2021/People/img/Ali_Erturk.png": 69449,
	"./2021/People/img/Amos_Tanay.png": 35046,
	"./2021/People/img/Andy_Yates.png": 90052,
	"./2021/People/img/Anton_Petrov.png": 61927,
	"./2021/People/img/Arvind_Pathak.png": 77428,
	"./2021/People/img/Barbora_Kozlíková.png": 4369,
	"./2021/People/img/Bjorn_Sommer.png": 24845,
	"./2021/People/img/Daniel_Weiskopf.png": 63313,
	"./2021/People/img/David_Goodsell.png": 85954,
	"./2021/People/img/Fabian_de_Kok-Mercado.png": 88858,
	"./2021/People/img/Inna_Boesselmann.png": 44858,
	"./2021/People/img/Irmtraud_Meyer.png": 47,
	"./2021/People/img/James_Procter.png": 73115,
	"./2021/People/img/Jessica_Xin_Hjaltelin.png": 68160,
	"./2021/People/img/Kay_Nieselt.png": 52063,
	"./2021/People/img/Kerstin_Howe.png": 40546,
	"./2021/People/img/Kirsten_Bos.png": 24888,
	"./2021/People/img/Lucy_Collinson.png": 87477,
	"./2021/People/img/Lydia_Gregg.png": 33335,
	"./2021/People/img/Léo_Guignard.png": 6787,
	"./2021/People/img/Marc_A._Marti-Renom.png": 10056,
	"./2021/People/img/Maria-Jesus_Martin.png": 83990,
	"./2021/People/img/Nadia_Magnenat-Thalmann.png": 78057,
	"./2021/People/img/Petra_Isenberg.png": 77481,
	"./2021/People/img/Raili_Pall.png": 96520,
	"./2021/People/img/Rob_Parton.png": 62963,
	"./2021/People/img/Rosane_Minghim.png": 6536,
	"./2021/People/img/Roser_Vento-Tormo.png": 29079,
	"./2021/People/img/Sameer_Velankar.png": 78518,
	"./2021/People/img/Seán_O'Donoghue.png": 82199,
	"./2021/People/img/Silvio_Tosatto.png": 9668,
	"./2021/People/img/Theodore_Alexandrov.png": 35946,
	"./2021/People/img/Unknown.png": 12483,
	"./2021/People/img/Yann_Ponty.png": 14901,
	"./2021/People/img/Yannick_Schwab.png": 57177,
	"./2021/People/organizers": 88929,
	"./2021/People/organizers.json": 88929,
	"./2021/People/session-chairs": 91122,
	"./2021/People/session-chairs.json": 91122,
	"./2021/People/speakers": 35780,
	"./2021/People/speakers.json": 35780,
	"./2021/Program/Index": 88568,
	"./2021/Program/Index.vue": 88568,
	"./2021/Program/program": 77605,
	"./2021/Program/program.json": 77605,
	"./2021/Sponsors/MainSponsor": 61665,
	"./2021/Sponsors/MainSponsor.vue": 61665,
	"./2021/Sponsors/embl.svg": 29280,
	"./2021/Sponsors/img/embl.svg": 996,
	"./2021/img/Hero/Background.jpg": 9173,
	"./2021/img/Hero/Large.jpg": 94816,
	"./2021/img/Hero/Medium.jpg": 41640,
	"./2022/Contact/Index": 41544,
	"./2022/Contact/Index.vue": 41544,
	"./2022/Index": 24637,
	"./2022/Index.vue": 24637,
	"./2022/Masterclass/Index": 85696,
	"./2022/Masterclass/Index.vue": 85696,
	"./2022/Masterclass/img/banner/hi_res.png": 25898,
	"./2022/Masterclass/img/banner/low_res.jpg": 38358,
	"./2022/People/Index": 98984,
	"./2022/People/Index.vue": 98984,
	"./2022/People/error": 96499,
	"./2022/People/error.json": 96499,
	"./2022/People/img/Alex_Jordan.png": 95177,
	"./2022/People/img/Alex_Ritter.png": 64990,
	"./2022/People/img/Ana_Crisan.png": 94182,
	"./2022/People/img/Andrea_Schafferhans.png": 76306,
	"./2022/People/img/Angela_Walker.png": 40816,
	"./2022/People/img/Arzu_Çöltekin.png": 45376,
	"./2022/People/img/Athma_Pai.png": 44091,
	"./2022/People/img/Bang_Wong.png": 75718,
	"./2022/People/img/Beata_Edyta_Mierzwa.png": 54536,
	"./2022/People/img/Ben_Fry.png": 12975,
	"./2022/People/img/Bjorn_Sommer.png": 18680,
	"./2022/People/img/Bongshin_Lee.png": 40953,
	"./2022/People/img/Bosco_Ho.png": 8118,
	"./2022/People/img/Bree_Aldridge.png": 78759,
	"./2022/People/img/Carl_Kesselman.png": 91464,
	"./2022/People/img/Carlota_Casals copy.png": 32155,
	"./2022/People/img/Carlota_Casals.png": 64540,
	"./2022/People/img/Carolyn_Ott.png": 51248,
	"./2022/People/img/Charles_Reilly.png": 5411,
	"./2022/People/img/Christian_Stolte.png": 32614,
	"./2022/People/img/Clodagh_O'Shea.png": 68665,
	"./2022/People/img/Daniel_Haehn.png": 94428,
	"./2022/People/img/Daniel_Janies.png": 28717,
	"./2022/People/img/David_Aanensen.png": 63652,
	"./2022/People/img/David_Goodsell.png": 24710,
	"./2022/People/img/David_Shattuck.png": 55695,
	"./2022/People/img/Devin_Sullivan.png": 23354,
	"./2022/People/img/Drew_Berry.png": 41517,
	"./2022/People/img/Eddie_Loh.png": 85691,
	"./2022/People/img/Elizabeth_Brunk.png": 71829,
	"./2022/People/img/Emmanuel_Reynaud.png": 44976,
	"./2022/People/img/Erez_Lieberman_Aiden.png": 91247,
	"./2022/People/img/Eric_Lécuyer.png": 96410,
	"./2022/People/img/Erik_Garrison.png": 51510,
	"./2022/People/img/Gaël_McGill.png": 38049,
	"./2022/People/img/Gokul_Upadhyayula.png": 5534,
	"./2022/People/img/Hannah_Somhegyi.png": 53019,
	"./2022/People/img/Hao_Li.png": 46670,
	"./2022/People/img/Helen_Berman.png": 55321,
	"./2022/People/img/Holly_Bik.png": 72640,
	"./2022/People/img/Ivan_Viola.png": 90722,
	"./2022/People/img/James_Michaelson.png": 91212,
	"./2022/People/img/James_Procter.png": 80753,
	"./2022/People/img/Jan_Kosinski.png": 16719,
	"./2022/People/img/Jane_Richardson.png": 47031,
	"./2022/People/img/Janet_Iwasa.png": 70618,
	"./2022/People/img/Jian_Ma.png": 65858,
	"./2022/People/img/John_Huddleston.png": 37097,
	"./2022/People/img/Juri_Rappsilber.png": 4354,
	"./2022/People/img/Kat_Holt.png": 35193,
	"./2022/People/img/Kathi_Zarnack.png": 24470,
	"./2022/People/img/Kathlynn_Alba.png": 81465,
	"./2022/People/img/Kay_Nieselt.png": 50303,
	"./2022/People/img/Kristin_Branson.png": 52162,
	"./2022/People/img/Lawrence_Hunter.png": 58491,
	"./2022/People/img/Loic_Royer.png": 3099,
	"./2022/People/img/Loïc_Royer.png": 474,
	"./2022/People/img/Lydia_Gregg.png": 54892,
	"./2022/People/img/Marc_Marti-Renom.png": 25075,
	"./2022/People/img/Marcin_Imielinski.png": 17288,
	"./2022/People/img/Martin_Krzywinski.png": 2421,
	"./2022/People/img/Martin_Smith.png": 82313,
	"./2022/People/img/Martina_Summer-Kutmon.png": 43069,
	"./2022/People/img/Meghan_Driscoll.png": 51781,
	"./2022/People/img/Michael_Joss.png": 85373,
	"./2022/People/img/Michael_Krone.png": 76665,
	"./2022/People/img/Michelle_Scott.png": 38892,
	"./2022/People/img/Nadia_Magnenat_Thalmann.png": 48862,
	"./2022/People/img/Nico_Scherf.png": 4516,
	"./2022/People/img/Nils_Gehlenborg.png": 99663,
	"./2022/People/img/Nils_Lindstrøm.png": 2645,
	"./2022/People/img/Patrick_Chain.png": 66962,
	"./2022/People/img/Richard_Neher.png": 54982,
	"./2022/People/img/Richard_Smith.png": 7006,
	"./2022/People/img/Richard_Weinberg.png": 56641,
	"./2022/People/img/Rob_Beiko.png": 15694,
	"./2022/People/img/Ruth_West.png": 25358,
	"./2022/People/img/Sabrina_de_A._Silveira.png": 49595,
	"./2022/People/img/Sameer_Velankar.png": 1829,
	"./2022/People/img/Sara_Sandin.png": 86941,
	"./2022/People/img/Sarah_Harris.png": 49442,
	"./2022/People/img/Scooter_Morris.png": 46293,
	"./2022/People/img/Scott_Fraser.png": 7591,
	"./2022/People/img/Seán_O'Donoghue.png": 29969,
	"./2022/People/img/Simon_Hayward.png": 61986,
	"./2022/People/img/Speakers.jpg": 37022,
	"./2022/People/img/Speakers.png": 4352,
	"./2022/People/img/Speakers_hi_res.png": 69098,
	"./2022/People/img/Stefan_Bruckner.png": 74385,
	"./2022/People/img/Steve_Pieper.png": 91155,
	"./2022/People/img/Ting_Wang.png": 58550,
	"./2022/People/img/Unknown.png": 26687,
	"./2022/People/img/Uwe_Ohler.png": 31139,
	"./2022/People/img/Virginie_Uhlmann.png": 30007,
	"./2022/People/img/Yoseph_Barash.png": 53373,
	"./2022/People/img/Yuko_Mimori-Kiyosue.png": 36322,
	"./2022/People/organizers": 58276,
	"./2022/People/organizers.json": 58276,
	"./2022/People/session-chairs": 87954,
	"./2022/People/session-chairs.json": 87954,
	"./2022/People/speakers": 26752,
	"./2022/People/speakers.json": 26752,
	"./2022/Platform/Index": 19925,
	"./2022/Platform/Index.vue": 19925,
	"./2022/Posters/Index": 5741,
	"./2022/Posters/Index.vue": 5741,
	"./2022/Program/Index": 95736,
	"./2022/Program/Index.vue": 95736,
	"./2022/Program/program": 57248,
	"./2022/Program/program.json": 57248,
	"./2022/Registration/Index": 51249,
	"./2022/Registration/Index.vue": 51249,
	"./2022/Sponsors/MainSponsor": 79207,
	"./2022/Sponsors/MainSponsor.vue": 79207,
	"./2022/Sponsors/img/Bridge-Gold+White.svg": 19330,
	"./2022/Sponsors/img/Bridge-Institute.svg": 48584,
	"./2022/Workshop/Index": 40443,
	"./2022/Workshop/Index.vue": 40443,
	"./2022/Workshop/img/Medium.jpeg": 74816,
	"./2022/img/Hero/Background.jpg": 13328,
	"./2022/img/Hero/Large.jpg": 84113,
	"./2022/img/Hero/Medium.jpg": 99509,
	"./2022/img/Logo.png": 9530,
	"./2022/img/Poster/Thumbnail_60px.jpg": 7062,
	"./2023/Contact/Index": 98425,
	"./2023/Contact/Index.vue": 98425,
	"./2023/Index": 51910,
	"./2023/Index.vue": 51910,
	"./2023/Masterclass/Index": 59801,
	"./2023/Masterclass/Index.vue": 59801,
	"./2023/Masterclass/img/banner/hi_res.png": 68215,
	"./2023/Masterclass/img/banner/low_res.jpg": 64961,
	"./2023/People/Index": 84657,
	"./2023/People/Index.vue": 84657,
	"./2023/People/img/Alex_Jordan.png": 77049,
	"./2023/People/img/Alex_Ritter.png": 87033,
	"./2023/People/img/Andrea_Schafferhans.png": 45933,
	"./2023/People/img/Arzu_Çöltekin.png": 85059,
	"./2023/People/img/Barbora_Kozlíková copy.png": 63818,
	"./2023/People/img/Barbora_Kozlíková.png": 6149,
	"./2023/People/img/Beata_Edyta_Mierzwa.png": 75072,
	"./2023/People/img/Björn_Sommer.png": 26667,
	"./2023/People/img/Christian_Stolte.png": 2376,
	"./2023/People/img/Christian_Stolte1.png": 33021,
	"./2023/People/img/Daniel_Haehn.png": 23073,
	"./2023/People/img/Drew_Berry.png": 84502,
	"./2023/People/img/Emmanuel_Reynaud.png": 2527,
	"./2023/People/img/Erez_Lieberman_Aiden.png": 37914,
	"./2023/People/img/Ivan_Viola.png": 24973,
	"./2023/People/img/James_Procter.png": 58627,
	"./2023/People/img/Juri_Rappsilber.jpg": 11155,
	"./2023/People/img/Juri_Rappsilber.png": 59314,
	"./2023/People/img/Kat_Holt.png": 77507,
	"./2023/People/img/Kathi_Zarnack.png": 27756,
	"./2023/People/img/Kay_Nieselt.png": 91332,
	"./2023/People/img/Lawrence_Hunter.png": 65329,
	"./2023/People/img/Lina_Kim.png": 33005,
	"./2023/People/img/Marc_A._Marti-Renom.png": 47091,
	"./2023/People/img/Martin_Dohrn.png": 56852,
	"./2023/People/img/Martin_Smith.png": 6041,
	"./2023/People/img/Martina_Summer-Kutmon.png": 75751,
	"./2023/People/img/Maryann_Heck.png": 10318,
	"./2023/People/img/Michael_Krone.png": 11219,
	"./2023/People/img/Michelle_Scott.png": 51086,
	"./2023/People/img/Nadia_Magnenat-Thalmann.png": 3128,
	"./2023/People/img/Nathalie_Sneider.png": 20064,
	"./2023/People/img/Neblina_Sikta.png": 36468,
	"./2023/People/img/Nico_Scherf.png": 75654,
	"./2023/People/img/Placeholder.png": 19754,
	"./2023/People/img/Richard_Neher.png": 90727,
	"./2023/People/img/Sabrina_de_A._Silveira.png": 66265,
	"./2023/People/img/Sandeep_Kaur.png": 71239,
	"./2023/People/img/Sarah_Harris.png": 69412,
	"./2023/People/img/Seán_O'Donoghue.png": 45029,
	"./2023/People/img/Srigokul_Upadhyayula.png": 50496,
	"./2023/People/img/Stefan_Bruckner.png": 60220,
	"./2023/People/img/Unknown.png": 92552,
	"./2023/People/img/Uwe_Ohler.png": 11093,
	"./2023/People/img/Virginie_Uhlmann.png": 45198,
	"./2023/People/img/Yuko_Mimori-Kiyosue.png": 30513,
	"./2023/People/img/large/Barbora_Kozlíková.jpg": 62324,
	"./2023/People/img/large/Christian_Stolte.jpg": 52359,
	"./2023/People/img/large/Drew_Berry.jpg": 51840,
	"./2023/People/img/large/Ivan_Viola.jpg": 16481,
	"./2023/People/img/large/Lina_Kim.jpg": 72106,
	"./2023/People/img/large/Marc_A._Marti-Renom.jpg": 71540,
	"./2023/People/img/large/Martin_Dohrn.jpg": 67252,
	"./2023/People/img/large/Sabrina_de_A._Silveira.jpg": 17460,
	"./2023/People/img/large/Seán_O'Donoghue.jpg": 89434,
	"./2023/People/img/large/Template.png": 86321,
	"./2023/People/img/large/Unknown.jpg": 22611,
	"./2023/People/img/large/very-large/Martin_Dohrn.jpg": 86796,
	"./2023/People/organizers": 71010,
	"./2023/People/organizers copy": 92955,
	"./2023/People/organizers copy.json": 92955,
	"./2023/People/organizers.json": 71010,
	"./2023/People/session-chairs": 74974,
	"./2023/People/session-chairs copy": 99030,
	"./2023/People/session-chairs copy.json": 99030,
	"./2023/People/session-chairs.json": 74974,
	"./2023/People/speakers": 60494,
	"./2023/People/speakers copy": 14881,
	"./2023/People/speakers copy.json": 14881,
	"./2023/People/speakers.json": 60494,
	"./2023/Posters/Index": 52532,
	"./2023/Posters/Index.vue": 52532,
	"./2023/Posters/img/IMG_7030.jpeg": 55096,
	"./2023/Posters/img/IMG_7031.jpeg": 77270,
	"./2023/Posters/img/IMG_7032.jpeg": 13932,
	"./2023/Posters/img/IMG_7033.jpeg": 45149,
	"./2023/Posters/img/IMG_7034.jpeg": 7546,
	"./2023/Posters/img/IMG_7035.jpeg": 56148,
	"./2023/Posters/img/IMG_7036.jpeg": 5351,
	"./2023/Posters/img/Play-button.png": 58702,
	"./2023/Posters/img/schol-ar+button.jpg": 72901,
	"./2023/Posters/img/schol-ar+button.png": 28365,
	"./2023/Posters/img/schol-ar.jpeg": 14957,
	"./2023/Program/Index": 68766,
	"./2023/Program/Index.vue": 68766,
	"./2023/Program/program": 61336,
	"./2023/Program/program copy": 67191,
	"./2023/Program/program copy.json": 67191,
	"./2023/Program/program.json": 61336,
	"./2023/Registration/Index": 92662,
	"./2023/Registration/Index.vue": 92662,
	"./2023/Registration/fees": 85732,
	"./2023/Registration/fees.json": 85732,
	"./2023/Showcase/Index": 83028,
	"./2023/Showcase/Index.vue": 83028,
	"./2023/Showcase/img/banner.jpeg": 27817,
	"./2023/Sponsors/Index": 85025,
	"./2023/Sponsors/Index.vue": 85025,
	"./2023/Sponsors/MainSponsor": 22232,
	"./2023/Sponsors/MainSponsor.vue": 22232,
	"./2023/Sponsors/img/CoB.svg": 6007,
	"./2023/Sponsors/img/EG.svg.png": 64874,
	"./2023/Sponsors/img/ISCB.jpeg": 22107,
	"./2023/Sponsors/img/Platano.svg": 35660,
	"./2023/Sponsors/img/embl.jpg": 88002,
	"./2023/Sponsors/img/embl.svg": 66037,
	"./2023/Sponsors/img/embo-primary-black.jpg": 99146,
	"./2023/Sponsors/img/embo-primary-black.svg": 12799,
	"./2023/Sponsors/img/embo-workshop.png": 69992,
	"./2023/VR/Index": 4928,
	"./2023/VR/Index.vue": 4928,
	"./2023/VR/img/banner.jpg": 46334,
	"./2023/Venue/Index": 43030,
	"./2023/Venue/Index.vue": 43030,
	"./2023/Venue/hotels": 38627,
	"./2023/Venue/hotels.json": 38627,
	"./2023/Venue/img/banner.jpeg": 5683,
	"./2023/img/Assets/Banner.gif": 21438,
	"./2023/img/Assets/IG-post.png": 64466,
	"./2023/img/Assets/Poster.jpg": 84779,
	"./2023/img/Assets/Poster.pdf": 66870,
	"./2023/img/Assets/Twitter-Fb.png": 45538,
	"./2023/img/Assets/holdingslide.jpg": 33563,
	"./2023/img/Hero/Background.jpg": 76938,
	"./2023/img/Hero/Large.png": 94153,
	"./2023/img/Hero/Medium.jpg": 67384,
	"./2023/img/Hero/Medium.png": 41388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36510;